import PropTypes from 'prop-types';
import React from 'react';
import CtaBusiness0 from './cta-business-0';
import CtaBusinessSm0 from './cta-business-sm-0';
import CtaBusinessSm1 from './cta-business-sm-1';
import CtaGeneral0 from './cta-general-0';

const RenderCta = ( { type, name } ) => {
    let ctaResult = ``;

    switch( type ) {
        case 'general-0':
            ctaResult = (
                <CtaGeneral0 primaryEventId={ `${name || 'general-0'}-primary` } secondaryEventId={ `${name || 'business-0'}-secondary` } />
            )
            break;
        case 'business-0':
            ctaResult = (
                <CtaBusiness0 primaryEventId={`${name || 'business-0'}-primary`} secondaryEventId={`${name || 'business-0'}-secondary`} />
            )
            break;
        case 'business-sm-0':
            ctaResult = (
                <CtaBusinessSm0 primaryEventId={`${name || 'business-sm-0'}-primary`} />
            )
            break;
        case 'business-sm-1':
            ctaResult = (
                <CtaBusinessSm1 primaryEventId={`${name || 'business-sm-1'}-primary`} />
            )
            break;
        default:
            ctaResult = (
                <CtaGeneral0 primaryEventId={`${name || 'general-0'}-primary`} secondaryEventId={`${name || 'business-0'}-secondary`}/>
            )
    }
    
    return (<aside>{ctaResult}</aside>)
};

RenderCta.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
};

export default RenderCta;
